import './index.scss';
import { createHooks } from '@wordpress/hooks';
import React, { Component } from "react";
import { __ } from '@wordpress/i18n';
import { useTable, usePagination } from "react-table";
import { CSVLink } from "react-csv";
import moment from 'moment';


function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }} = useTable({columns, data,initialState: { pageIndex: 0 }},
    usePagination
  );
 

  // Render the UI for your table
  return (
    <>
    <table class="course-list-table" {...getTableProps()}>
      <thead>
         {headerGroups.map(headerGroup => (
             <tr {...headerGroup.getHeaderGroupProps()}>
               {headerGroup.headers.map(column => (
                   <th
                       {...column.getHeaderProps()}
                       className={column.className}
                   >
                     {column.render('Header')}
                   </th>
               ))}
             </tr>
         ))}
      </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr class="course-list-table-data-row"{...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td className={cell.column.className} {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="table-pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </button>{" "}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </button>{" "}
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button>{" "}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>{" "}
      </div>
    </>
  );
}


class CourseList extends Component {
    constructor(props) {
      super(props);
  
        this.state = {
          isLoaded: false,
          isProVersion:false,
          start_date:moment(new Date(wisdm_ld_reports_common_script_data.start_date)).unix(),
          end_date:moment(new Date(wisdm_ld_reports_common_script_data.end_date)).unix(),
          reportTypeInUse: wisdm_learndash_reports_front_end_script_course_list.report_type,
          error: null,
        };

        this.applyFilters           = this.applyFilters.bind(this);
        this.handleReportTypeChange = this.handleReportTypeChange.bind(this);
        this.getExcelFile           = this.getExcelFile.bind(this);
      }
    
    componentDidMount() {    
        this.getCourseListStateData();
        document.addEventListener('wisdm-ld-reports-filters-applied', this.applyFilters);
        document.addEventListener('wisdm-ld-reports-report-type-selected', this.handleReportTypeChange);

    }

    handleReportTypeChange(event) {
      this.setState({reportTypeInUse:event.detail.active_reports_tab});
      if ( 'quiz-reports' == event.detail.active_reports_tab ) {
        wisdm_reports_change_block_visibility('.wp-block-wisdm-learndash-reports-course-list', false);
      } else {
        wisdm_reports_change_block_visibility('.wp-block-wisdm-learndash-reports-course-list', true);
      }
    }

    applyFilters(event) {
      let start_date = this.state.start_date;
      let end_date   = this.state.end_date;
      let category   = event.detail.selected_categories;
      let group      = event.detail.selected_groups
      let course     = event.detail.selected_courses;
      let lesson     = event.detail.selected_lessons;
      let topic      = event.detail.selected_topics;
      let learner    = event.detail.selected_learners;
      let request_url = '/rp/v1/course-list-info/?start_date=' + start_date + '&end_date=' + end_date + '&category=' + category + '&group=' + group + '&course=' + course + '&lesson=' + lesson + '&topic=' + topic + '&learner=' + learner;
      this.getCourseListStateData(request_url);
    }

    getTableHeadersByType(response) {
      let headers= []; 
      let table_header_names = {
        id                    : __('ID', 'learndash-reports-by-wisdmlabs'),
        category              : wisdm_reports_get_ld_custom_lebel_if_avaiable('Course') + ' ' + __('Category', 'learndash-reports-by-wisdmlabs'),
        course                : wisdm_reports_get_ld_custom_lebel_if_avaiable('Course') + ' ' + __('Title', 'learndash-reports-by-wisdmlabs'),
        groups                : __('Groups', 'learndash-reports-by-wisdmlabs'),
        user_name             : __('Learner', 'learndash-reports-by-wisdmlabs'),
        instructors           : __('Instructor', 'learndash-reports-by-wisdmlabs'),
        students              : __('No. Of Students', 'learndash-reports-by-wisdmlabs'),
        start_date            : __('Start Date', 'learndash-reports-by-wisdmlabs'),
        started               : __('Started On', 'learndash-reports-by-wisdmlabs'),
        end_date              : __('End Date', 'learndash-reports-by-wisdmlabs'),
        completed             : __('Completed On', 'learndash-reports-by-wisdmlabs'),
        lesson                : __('Lesson', 'learndash-reports-by-wisdmlabs'),
        course_progress       : __('Course Progress (in %)', 'learndash-reports-by-wisdmlabs'),
        quizzes               : __('No. Of', 'learndash-reports-by-wisdmlabs') + ' ' + wisdm_reports_get_ld_custom_lebel_if_avaiable('Quizzes') ,
        quiz_count            : __('No. Of', 'learndash-reports-by-wisdmlabs') + ' ' + wisdm_reports_get_ld_custom_lebel_if_avaiable('Quizzes'),
        quiz_title            : wisdm_reports_get_ld_custom_lebel_if_avaiable('Quiz') + ' ' + __('Title', 'learndash-reports-by-wisdmlabs'),
        total_attempts        : __('Total Attempts', 'learndash-reports-by-wisdmlabs'),
        pass_count            : __('No. Of Quizzes Pass', 'learndash-reports-by-wisdmlabs'),
        fail_count            : __('No. Of Quizzes Fail', 'learndash-reports-by-wisdmlabs'),
        time_spent            : __('Avg. Time Spent', 'learndash-reports-by-wisdmlabs'),
        quiz_attendant_count  : __('No. Of Students Completed Quiz', 'learndash-reports-by-wisdmlabs'),
        quiz_attendant_count  : __('No. Of Students Completed Quiz', 'learndash-reports-by-wisdmlabs'),
        topic_title           : wisdm_reports_get_ld_custom_lebel_if_avaiable('Topic') + ' ' + __(' Title', 'learndash-reports-by-wisdmlabs'),
        topic_completion_count: wisdm_reports_get_ld_custom_lebel_if_avaiable('Topic') + ' ' +__('Completed By Students', 'learndash-reports-by-wisdmlabs'),
        quiz_time             : wisdm_reports_get_ld_custom_lebel_if_avaiable('Quiz') + ' ' + __('Time', 'learndash-reports-by-wisdmlabs'),
        quiz_attempts         : wisdm_reports_get_ld_custom_lebel_if_avaiable('Quiz') + ' ' + __('Attempts', 'learndash-reports-by-wisdmlabs'),
      };
      
      if (null!=response && response.length>0) {
        var response_headers = Object.keys(response[0]);
        if (response_headers.length>0) {
          for (let i = 0; i < response_headers.length; i++) {
            let name = response_headers[i];
            if (undefined==table_header_names[name]) {
              headers.push({"Header":name, "accessor":name, className: 'table-'+name});
            } else {
              headers.push({"Header":table_header_names[name], "accessor":name, className: 'table-'+name});
            }  
          }
        }
      }
      return headers;
    }


    getCourseListStateData(request_url='/rp/v1/course-list-info') {
        this.setState({
          isLoaded: false,
        });
        wp.apiFetch({
            path: request_url,
         }).then(response => {
             if (undefined==response) {
               response = [];
             }
              this.setState(
                      {
                      isLoaded: true,
                      error:null,
                      isProVersion:wisdm_learndash_reports_front_end_script_course_list.is_pro_version_active,
                      tableHeaders: this.getTableHeadersByType(response),
                      tableData: response,
                    }); 
            }).catch((error) => {
              this.setState({
                error:error,
              graph_summary:[],
                series:[],
                isLoaded: true,
              });
            });
    }

    getExcelFile() {
      jQuery.ajax(
        {
            type: 'POST',
            url: wisdm_learndash_reports_front_end_script_course_list.ajaxurl,
            dataType: "JSON",
            data: {
                    action:'export_course_statistics',
                    report_nonce:wisdm_learndash_reports_front_end_script_course_list.report_nonce,
                    tableHeaders:this.state.tableHeaders,
                    tableData:JSON.stringify(this.state.tableData),
                },
            error: function(eventData){
                if('timeout' === eventData['status']) {     
                     alert('Request Timed Out');         
                }
            },
            success: function(response){
              if ('success'==response.status) {
                window.open(response.data, '_blank');
                //process download
              } else {
                alert(response.data);
              }
            }, timeout: 60000 // sets timeout to 60 seconds
        });
    }

  
    render() {
      let body = '';
      if(''!=this.state.reportTypeInUse && 'default-ld-reports'!=this.state.reportTypeInUse) {
        body = '';
      }else if (!this.state.isLoaded) {
        body = <div class="wisdm-learndash-reports-chart-block wisdm-ld-loading">
            <div>
              {__('Loading...', 'learndash-reports-by-wisdmlabs')}
            </div>
          </div>;
    } else if (this.state.error) {
        // error
        body = <div class="wisdm-learndash-reports-chart-block error">
              <div>{this.state.error.message}</div>
              </div>;
    } else {        
        body = 
        <div class="wisdm-learndash-reports-chart-block">
          <div class="wisdm-learndash-reports-course-list table-chart-container">
            <div class="course-list-table-container">
              <div class="course-list-table-header">
                <div className='chart-title'>
                  <span>{__('Detailed', 'learndash-reports-by-wisdmlabs') + ' ' + wisdm_reports_get_ld_custom_lebel_if_avaiable('Course') + ' ' + __('Reports', 'learndash-reports-by-wisdmlabs')}</span>
                </div>
                <div class="course-list-table-download-options">
                  <span>{__('Download ','learndash-reports-by-wisdmlabs')}</span> 
                  {
                    this.state.isProVersion?(<CSVLink data={this.state.tableData} filename={"exported_table.csv"}
                    className="btn btn-primary" target="_blank">
                    <button className="download-csv-button"><img src={wisdm_ld_reports_common_script_data.plugin_asset_url + '/images/csv.svg'}></img></button></CSVLink>):(<button disabled className="disabled download-csv-button" title={__('Available in pro version', 'learndash-reports-by-wisdmlabs')}>
                    <img src={wisdm_ld_reports_common_script_data.plugin_asset_url + '/images/csv.svg'}></img>
                  </button>)
                  }
                  {
                    this.state.isProVersion?(<span onClick={this.getExcelFile}
                    className="btn btn-primary" target="_blank">
                    <button className="download-csv-button"><img src={wisdm_ld_reports_common_script_data.plugin_asset_url + '/images/xls.svg'}></img></button></span>):(<button disabled className="disabled download-csv-button" title={__('Available in pro version', 'learndash-reports-by-wisdmlabs')}>
                    <img src={wisdm_ld_reports_common_script_data.plugin_asset_url + '/images/xls.svg'}></img>
                  </button>)
                  }
                </div>
              </div>
              <Table columns={this.state.tableHeaders} data={this.state.tableData}/>
            </div>
          </div>
        </div>;
    
    }
      return (body);
    }
  }

document.addEventListener("DOMContentLoaded", function(event) {
    let elem = document.getElementsByClassName('wisdm-learndash-reports-course-list');
    if (elem.length>0) {
      ReactDOM.render(React.createElement(CourseList), elem[0]); 
    }
});




